import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_ModelCoefficientSetRow, WB_ModelingSessionProdRRow,
    WB_ModelRow,
    WB_PeriodRow,
    WB_PlanProductGroupRow,
    WB_ProductGroupRow,
    WB_Published_ModelRow,
    WB_SimulationInputRelationshipRow, WB_SimulationInputRow, WB_SimulationMetricRow,
    WB_SimulationPredictorRelationshipRow, WB_SimulationRelationshipRow,
    WB_SimulationRow,
    WB_SimulationTypeRow,
    WB_UserRow
} from "../PA.Core/PAdbSchemaRows";
import {PASearch} from "../PA.Core/PASearch";

import {
    esWB_Model,
    esWB_Model_Coeff_Set,
    esWB_Model_Coeff_SetR, esWB_Modeling_Session_ProdR,
    esWB_Period,
    esWB_Product_Group,
    esWB_Published_Model,
    esWB_Simulation, esWB_Simulation_Input,
    esWB_Simulation_Input_Relationship,
    esWB_Simulation_Metric,
    esWB_Simulation_Predictor_Relationship,
    esWB_Simulation_Product, esWB_Simulation_Relationship,
    esWB_Simulation_Type,
    esWB_Simulation_Type_Input_Relationship,
    esWB_User
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IHaveModel} from "../PA.Model.Core/PA.Model.IF.Aspects";
import {
    IHaveSimulationCalculator,
    ISimulationCalculator,
    ISimulationSummaryDetail
} from "../PA.Simulation.Services/SimulationServices.IF"
import {ModelBO} from "../PA.Model.BusinessObjects/ModelBO";
import {SimulationCalculator} from "../PA.Simulation.Services/SimulationCalculator";
import {
    IHaveSimulationCollection,
    IHaveSimulationCollectionCubeSource,
    ISimulation,
    ISimulationChangedEvent,
    ISimulationModel
} from "../PA.Simulation.Core/PA.Simulation.IF.Aspects"
import {IHaveProductGroups} from "../PA.Core/PA.Core.IF.Aspects";
import {BehaviorSubject} from "rxjs";
import {
    ICellMetric,
    ICubePerspective,
    ICubePerspectiveOptions,
    ICubeSource,
    ICubeSourceChangeEvent,
    IDimensionCompositeKeys,
    IDimensionDistinctKeys
} from "../PA.HyperRectangle.Core/PA.HyperRectangle.IF";
import {DimensionType, IHierarchy} from "../PA.Core/PA.Core.IF.Hierarchy";
import {Perspective} from "../PA.HyperRectangle.Core/Perspective";
import {SimulationPredictorInputCell} from "./SimulationPredictorInputCell";
import {ExecutionSerializer} from "../PA.Core/Basic/ExecutionSerializer";
import {PeriodService} from "../PA.MD.Services/PeriodService";
import {PeriodHierarchy} from "../PA.MD.Services/PeriodHierarchy";
import {ProductHierarchy} from "../PA.MD.Services/ProductHierarchy";
import {SimulatorPredictorMetric} from "./SimulatorPredictorMetric";
import {SimulatorInputMetric} from './SimulatorInputMetric';
import {PricingEngine} from "../PA.MD.Core/PricingEngine";
import {IwbProductCondition} from "../PA.Core/PAdbSchemaRowsIF";
import {SimulationBOValidation} from "./SimulationBO.validation";
import {SimulationCollectionCubeSource} from "./SimulationCollectionCubeSource";
import {DimensionPlacement} from "../PA.Reporting.Core/PA.Reporting.IF";
import {CellMetricUtils} from "../PA.HyperRectangle.Core/CellMetricUtils";

export interface createNewOptions {
    SimulationTypeId: number,
    PublishedModelId: number
}

export class SimulationBO
    implements IBusinessObject,
        ISimulation,
        ICubeSource,
        IHaveModel,
        IHaveSimulationCalculator,
        IHaveProductGroups,
        IHaveSimulationCollection,
        IHaveSimulationCollectionCubeSource
{

    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Simulation: WB_SimulationRow

    arrModel: ISimulationModel[]

    summaryRow: ISimulationSummaryDetail
    summaryDetailRows: ISimulationSummaryDetail[]
    summaryDetailTotalRows: ISimulationSummaryDetail[]

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Simulation'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Simulation = null;

        this.arrModel = []
        this.summaryRow = null;
        this.summaryDetailRows = []
        this.summaryDetailTotalRows = []


        this.ISimulation_init()
        this.IHaveModel_init()
        this.IHaveProductGroups_init()
        this.IHaveSimulationCalculator_init()
        this.IHaveSimulationPredictorsAndInputs_init();
        this.ICubeSource_init()
        this.IHaveSimulationCollection_init()
        this.IHaveSimulationCollectionCubeSource_init()


    }

    get WB_Simulation(): WB_SimulationRow {
        return this.drWB_Simulation;
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: createNewOptions): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Simulation");
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (self.dbContext == null) {
                let sError = "Unable to determine dbContext for New Simulation.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            let typeRow: WB_SimulationTypeRow = undefined
            let modelRow: WB_Published_ModelRow = undefined
            let productGroupIDs: number [] = []
            let productGroups: WB_ProductGroupRow[] = []
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)


            // Create record using dbContext
            self.dbContext.find(esWB_Published_Model, options.PublishedModelId)
                .then((aModelRecord: WB_Published_ModelRow) => {
                    if (_.isEmpty(aModelRecord))
                        return
                    modelRow = aModelRecord
                    return self.dbContext.find(esWB_User, aModelRecord.cif.WB_AUTHUSR_ID_CREATEDBY)
                })
                .then((aUserRow: WB_UserRow) => {
                    modelRow.WB_UserRow_CreatedBy = aUserRow

                    return self.dbContext.findAll(esWB_Simulation_Type, {where: {WB_SIMULATIONM_ID: options.SimulationTypeId}}, {with: [esWB_Simulation_Type_Input_Relationship]})
                })
                .then((arrTypeRecord: WB_SimulationTypeRow[]) => {
                    if (_.isEmpty(arrTypeRecord))
                        return
                    typeRow = arrTypeRecord[0]

                    return self.dbContext.findAll(esWB_Simulation_Input, {
                        where: {
                            WB_SIMULATION_INPUT_ID: {
                                inq: _.map(typeRow.WB_SimulationTypeInputRelationshipRows, aRow => {
                                    return aRow.cif.WB_SIMULATION_INPUT_ID
                                })
                            }
                        }
                    })
                })
                .then((arrInput: WB_SimulationInputRow[]) => {
                    _.forEach(typeRow.WB_SimulationTypeInputRelationshipRows, aRow => {
                        aRow.WB_SimulationInputRow = _.first(_.filter(arrInput, anInput => anInput.cif.WB_SIMULATION_INPUT_ID == aRow.cif.WB_SIMULATION_INPUT_ID))
                    })
                    return self.dbContext.createRecordWithKey(esWB_Simulation)
                })
                .then((newSimulationRow: WB_SimulationRow) => {
                    newSimulationRow.setDefaults();
                    self.drWB_Simulation = newSimulationRow;
                    self.drWB_Simulation.cif.WB_CUST_ID = 0
                    self.drWB_Simulation.cif.WB_PUBLISHED_MODEL_ID = modelRow.cif.WB_PUBLISHED_MODEL_ID
                    self.drWB_Simulation.WB_PublishedModelRow = modelRow
                    self.drWB_Simulation.cif.WB_SIMULATIONM_ID = typeRow.cif.WB_SIMULATIONM_ID
                    self.drWB_Simulation.WB_SimulationTypeRow = typeRow
                    self.dbContext.add(esWB_Simulation, newSimulationRow);
                    self.drWB_Simulation.WB_UserRow_CreatedBy = usrContext.User

                    self.Identity.setAll(self.WB_Simulation.cif.WB_SIMULATION_ID, self.WB_Simulation.cif.SIMULATION_ID, self.WB_Simulation.cif.SIMULATION_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Simulation, 'WB_SIMULATION_ID', 'SIMULATION_ID', 'SIMULATION_NAME');
                    self._bIsLoaded = true;
                    return self._AfterBoLoadCompleteInternal()
                })
                .then(() => {
                    // Default Metric Compare List for new Simulation
                    let persOpts = self.drWB_Simulation.ComparePerspectiveOptions
                    let compTblOpts = self.drWB_Simulation.CompareTableOptions
                    compTblOpts.MetricOrder = self.SimulationCollectionCubeSource.DefaultMetricList
                    compTblOpts.MetricPlacement = DimensionPlacement.OnRows,
                    persOpts.MetricIds = compTblOpts.MetricOrder
                    self.drWB_Simulation.ComparePerspectiveOptions = persOpts
                    self.drWB_Simulation.CompareTableOptions = compTblOpts



                    self.LoadProgressProvider.finish();
                    self._OnLoadComplete = null;
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err);
                    error(err)
                });
        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                let sError = "Simulation Type already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (self.dbContext == null)
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for Simulation.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = SimulationBO.createRecordResolver({dbContext: self.dbContext});
                recordResolverLoadPromise = SimulationBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
                .then(function () {
                    let newSimulationRow: any = recordResolver.get(esWB_Simulation, anId);

                    if (_.isEmpty(newSimulationRow)) {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_Simulation = newSimulationRow;
                    self.Identity.setAll(self.WB_Simulation.cif.WB_SIMULATION_ID, self.WB_Simulation.cif.SIMULATION_ID, self.WB_Simulation.cif.SIMULATION_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Simulation, 'WB_SIMULATION_ID', 'SIMULATION_ID', 'SIMULATION_NAME');
                    self._bIsLoaded = true;
                    return self._AfterBoLoadCompleteInternal()
                })
                .then((newSimulationRow: any) => {
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch((err: any) => {
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });

        return this._OnLoadComplete;
    }

    private _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            let tasks: Promise<any>[] = [];

            self.LoadProgressProvider.setProgressMessage('Model.Load', 'Processing Model Loaded Data');
            tasks.push(self.OnISimulationLoaded())
            tasks.push(self.OnIHaveModelLoaded)
            tasks.push(self.IHaveSimulationCalculator_OnLoadComplete())
            tasks.push(self.OnIHaveProductGroupsLoaded)
            tasks.push(self.OnLoadSummary())
            Promise.all(tasks)
                .then((ignore: any) => {
                    return self.IHaveSimulationPredictorsAndInputs_afterLoadComplete()
                })
                .then((ignore: any) => {
                    return self.OnICubeSourceLoadComplete
                })
                .then((ignore: any) => {
                    return self.IHaveSimulationCollection_afterLoadComplete()
                })
                .then((ignore: any) => {
                    return self.IHaveSimulationCollectionCubeSource_afterLoadComplete()
                })
                .then((ignore: any) => {
                    resolve()
                })
                .catch((err: any) => {
                    error(err);
                });
        })
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options?: any): Promise<IBusinessObject> {

        let self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.drWB_Simulation.cif.SIMULATION_NAME + "(" + self.drWB_Simulation.cif.SIMULATION_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                let sError = "Unable to determine dbContext to Validate Simulation.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            SimulationBOValidation.Validation(self)
                .then((ignore) => {
                    if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        self._bIsValidated = false;
                    } else {
                        self._bIsValidated = true;
                    }
                    self.ValidateProgressProvider.finish();
                    resolve(self);
                }).catch((err) => {
                self._bIsValidated = false;
                self.ValidateProgressProvider.exception(err);
                resolve(self);
            });
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;

        this.SaveProgressProvider.start("Saving " + self.WB_Simulation.cif.SIMULATION_NAME + "(" + self.WB_Simulation.cif.SIMULATION_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // We could search the tree if there is any record where store isn't set.

            if (self.dbContext == null) {
                self._bIsSaved = false;
                let sError = "Unable to determine dbContext to Save Simulation";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }

            let bDone = false;
            self.Validate({})
                .then((ignore) => {
                    if (!self.bIsValidated) {
                        self._bIsSaved = false;
                        bDone = true;
                        self.SaveProgressProvider.finish();
                        resolve(self);
                        return;
                    }
                    return saveFunction(esWB_Simulation, self.drWB_Simulation, {})
                })
                .then(() => {
                    let tasks: Promise<any>[] = []
                    tasks.push(saveFunction(esWB_Simulation_Relationship, self.drWB_Simulation.WB_SimulationRelationshipRows))
                    tasks.push(saveFunction(esWB_Simulation_Input_Relationship, self.drWB_Simulation.WB_SimulationInputRelationshipRows))
                    tasks.push(saveFunction(esWB_Simulation_Predictor_Relationship, self.drWB_Simulation.WB_SimulationPredictorRelationshipRows))
                    tasks.push(saveFunction(esWB_Simulation_Product, self.drWB_Simulation.WB_SimulationProductRows))
                    return Promise.all(tasks)
                })
                .then((ignored) => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(() => {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    reject(self);
                })
        })
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + self.drWB_Simulation.cif.SIMULATION_NAME + "(" + self.drWB_Simulation.cif.SIMULATION_ID + ")");

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_Simulation.WB_SimulationInputRelationshipRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted()
                }
            })
            _.forEach(self.drWB_Simulation.WB_SimulationPredictorRelationshipRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted()
                }
            })
            _.forEach(self.drWB_Simulation.WB_SimulationProductRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted()
                }
            })
            _.forEach(self.drWB_Simulation.WB_SimulationMetricRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted()
                }
            })
            self.drWB_Simulation.markDeleted();

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //<editor-fold desc = "Results Summary">

    OnLoadSummary(): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            PASearch.find('vWB_Simulation_Result_Metrics', {WB_SIMULATION_ID: self.drWB_Simulation.cif.WB_SIMULATION_ID},
                {WB_SIMULATION_ID: {type: "number"}}, [],
                0, [])
                .then((result: ISimulationSummaryDetail[]) => {
                    if (!_.isEmpty(result))
                        self.summaryRow = _.first(result)

                    return PASearch.find('vWB_Simulation_Result_Detail_Total', {WB_SIMULATION_ID: self.drWB_Simulation.cif.WB_SIMULATION_ID},
                        {WB_SIMULATION_ID: {type: "number"}}, [],
                        0, [])
                }).then((arrResult: ISimulationSummaryDetail[]) => {
                self.summaryDetailTotalRows = arrResult

                return PASearch.find('vWB_Simulation_Result_Details', {WB_SIMULATION_ID: self.drWB_Simulation.cif.WB_SIMULATION_ID},
                    {WB_SIMULATION_ID: {type: "number"}}, [],
                    0, [])
            }).then((arrResult: ISimulationSummaryDetail[]) => {
                self.summaryDetailRows = arrResult
                resolve()
            })

        })

    }

    async ReloadMetrics(): Promise<void> {
        const self = this

        self.dbContext.purgeCache(esWB_Simulation_Metric, self.WB_Simulation.WB_SimulationMetricRows)
        let rr = new ESRecordResolver(self.dbContext, {
            standardConditions: {
                [esWB_Simulation_Metric]: {"DELETED_IND": {"notIn": ['1']}}
            }
        })

        let metrics = await rr.queryAllWithRelationships(esWB_Simulation_Metric, {
            where: {
                WB_SIMULATION_ID: self.WB_Simulation?.cif.WB_SIMULATION_ID,
                DELETED_IND: {"notIn": ['1']}
            }
        })

        _.forEach(metrics, (aMetric: WB_SimulationMetricRow) => {
            self.WB_Simulation.WB_SimulationMetricRows.push(aMetric)
        })

        return
    }


    //</editor-fold>

    //<editor-fold desc = "Input Operations -- Why is this part of the BO? vs the UI controller">

    get MetricSummaryRow(): ISimulationSummaryDetail {
        return this.summaryRow
    }

    get MetricDetailRows(): ISimulationSummaryDetail[] {
        return this.summaryDetailRows
    }

    get MetricDetailTotalRows(): ISimulationSummaryDetail[] {
        return this.summaryDetailTotalRows
    }


    //</editor-fold>

    //<editor-fold desc = "IHaveSimulationPredictorsAndInputs Operations">

    private _onIHaveSimulationPredictorsAndInputsChanged: BehaviorSubject<SimulationBO>
    private _qsSimulationPredictorAndInputs_sync: ExecutionSerializer

    private IHaveSimulationPredictorsAndInputs_init() {
        const self = this
        this._onIHaveSimulationPredictorsAndInputsChanged = new BehaviorSubject<SimulationBO>(self)
        this._qsSimulationPredictorAndInputs_sync = new ExecutionSerializer(this, this._PredictorsAndInputs_sync.bind(self),
            [{}], 250, false)
    }

    private async IHaveSimulationPredictorsAndInputs_afterLoadComplete() {
        const self = this

        //  Watch for Date changes/ PG Changes
        self.SimulationPropertyChanged.subscribe((event) => {
            if (_.isEmpty(event))
                return

            switch (event?.PropertyChanged) {
                case "START_DT":
                case "END_DT":
                    self.PredictorsAndInputs_sync()
                    break;
            }
        })

        await self.OnIHaveProductGroupsLoaded

        self.ProductGroupsChanged.subscribe((obj) => {
            self.PredictorsAndInputs_sync()
        })


    }


    get OnIHaveSimulationPredictorsAndInputsChanged(): BehaviorSubject<SimulationBO> {
        return this._onIHaveSimulationPredictorsAndInputsChanged
    }

    PredictorsAndInputs_sync(): void {
        //  debounce calls ...
        console.log("Synchronizing PredictorsAndInputs: qsRun")
        this._qsSimulationPredictorAndInputs_sync.Run({})
    }

    private async _PredictorsAndInputs_sync(opts: any): Promise<void> {
        const self = this

        // Determine the Periods
        let arrPeriods
            = await PeriodService.getPeriodsByPeriodTypeWbIDDateRange(self.Model.WB_Model.cif.WB_PERIODM_ID,
            self.WB_Simulation.StartDate, self.WB_Simulation.EndDate)

        let arrPrdGrps = self.ProductGroups

        let dctPeriods = _.keyBy(arrPeriods, (a) => a.cif.WB_PERIOD_ID)
        let dctPrdGrps = _.keyBy(arrPrdGrps, (a) => a.cif.WB_PRDGRP_ID)

        let dctPredictors: { [wbPrdGrpId: number]: { [wbPeriodId: number]: WB_SimulationPredictorRelationshipRow } } = {}

        // Sync up Predictors
        _.forEach(self.WB_Simulation.WB_SimulationPredictorRelationshipRows, (aRow) => {

            if (!aRow.isActive)
                return

            // Check if the Row is in Scope
            if (!(aRow.cif.WB_PERIOD_ID in dctPeriods)) {
                aRow.markDeleted()
                return
            }

            if (!(aRow.cif.WB_PRDGRP_ID in dctPrdGrps)) {
                aRow.markDeleted()
                return
            }

            if (!(aRow.cif.WB_PRDGRP_ID in dctPredictors)) {
                dctPredictors[aRow.cif.WB_PRDGRP_ID] = {}
            }

            if (!(aRow.cif.WB_PERIOD_ID in dctPredictors[aRow.cif.WB_PRDGRP_ID])) {
                dctPredictors[aRow.cif.WB_PRDGRP_ID][aRow.cif.WB_PERIOD_ID] = aRow
            } else {
                // duplicate
                aRow.markDeleted()
                return
            }
        })

        // Determine Missing Predictors, Add them
        for (let aPrdGrp of arrPrdGrps) {
            for (let aPeriod of arrPeriods) {
                //--
                let wbPrdGrpId = aPrdGrp.cif.WB_PRDGRP_ID
                let wbPeriodId = aPeriod.cif.WB_PERIOD_ID

                if (!(wbPrdGrpId in dctPredictors)) {
                    dctPredictors[wbPrdGrpId] = {}
                }

                if (!(wbPeriodId in dctPredictors[wbPrdGrpId])) {
                    //-- Add missing
                    let aNewRow
                        = <WB_SimulationPredictorRelationshipRow>await self.dbContext.createRecordWithKey(esWB_Simulation_Predictor_Relationship)
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_SIMULATION_ID = self.WB_Simulation.cif.WB_SIMULATION_ID
                    aNewRow.WB_SimulationRow = self.WB_Simulation
                    aNewRow.cif.WB_PRDGRP_ID = wbPrdGrpId
                    aNewRow.cif.WB_PERIOD_ID = wbPeriodId
                    self.dbContext.add(esWB_Simulation_Predictor_Relationship, aNewRow)

                    if (!aNewRow.WB_ProductGroupRow)
                        aNewRow.WB_ProductGroupRow = <WB_ProductGroupRow>(await self.dbContext.findUsingCache(esWB_Product_Group, [wbPrdGrpId]))[0]

                    if (!aNewRow.WB_PeriodRow)
                        aNewRow.WB_PeriodRow = <WB_PeriodRow>(await self.dbContext.findUsingCache(esWB_Period, [wbPeriodId]))[0]

                    dctPredictors[wbPrdGrpId][wbPeriodId] = aNewRow
                }

            } // Next Period
        } // Next Product Group


        let dctInputs: { [wbPrdGrpId: number]: { [wbPeriodId: number]: WB_SimulationInputRelationshipRow } } = {}

        // Sync up Inputs
        _.forEach(self.WB_Simulation.WB_SimulationInputRelationshipRows, (aRow) => {

            if (!aRow.isActive)
                return

            // Check if the Row is in Scope
            if (!(aRow.cif.WB_PERIOD_ID in dctPeriods)) {
                aRow.markDeleted()
                return
            }

            if (!(aRow.cif.WB_PRDGRP_ID in dctPrdGrps)) {
                aRow.markDeleted()
                return
            }

            if (!(aRow.cif.WB_PRDGRP_ID in dctInputs)) {
                dctInputs[aRow.cif.WB_PRDGRP_ID] = {}
            }

            if (!(aRow.cif.WB_PERIOD_ID in dctInputs[aRow.cif.WB_PRDGRP_ID])) {
                dctInputs[aRow.cif.WB_PRDGRP_ID][aRow.cif.WB_PERIOD_ID] = aRow
            } else {
                // duplicate
                aRow.markDeleted()
                return
            }
        })

        // Determine Missing Inputs, Add them
        for (let aPrdGrp of arrPrdGrps) {
            for (let aPeriod of arrPeriods) {
                //--
                let wbPrdGrpId = aPrdGrp.cif.WB_PRDGRP_ID
                let wbPeriodId = aPeriod.cif.WB_PERIOD_ID

                if (!(wbPrdGrpId in dctInputs)) {
                    dctInputs[wbPrdGrpId] = {}
                }

                if (!(wbPeriodId in dctInputs[wbPrdGrpId])) {
                    //-- Add missing
                    let aNewRow
                        = <WB_SimulationInputRelationshipRow>await self.dbContext.createRecordWithKey(esWB_Simulation_Input_Relationship)
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_SIMULATION_ID = self.WB_Simulation.cif.WB_SIMULATION_ID
                    aNewRow.WB_SimulationRow = self.WB_Simulation
                    aNewRow.cif.WB_PRDGRP_ID = wbPrdGrpId
                    aNewRow.cif.WB_PERIOD_ID = wbPeriodId
                    self.dbContext.add(esWB_Simulation_Input_Relationship, aNewRow)

                    if (!aNewRow.WB_ProductGroupRow)
                        aNewRow.WB_ProductGroupRow = <WB_ProductGroupRow>(await self.dbContext.findUsingCache(esWB_Product_Group, [wbPrdGrpId]))[0]

                    if (!aNewRow.WB_PeriodRow)
                        aNewRow.WB_PeriodRow = <WB_PeriodRow>(await self.dbContext.findUsingCache(esWB_Period, [wbPeriodId]))[0]

                    dctInputs[wbPrdGrpId][wbPeriodId] = aNewRow
                }

            } // Next Period
        } // Next Product Group


        self.OnIHaveSimulationPredictorsAndInputsChanged.next(self)
    }


    //</editor-fold>

    //<editor-fold desc = "ISimulator Operations">

    private _simulationPropertyChanged: BehaviorSubject<ISimulationChangedEvent>;

    ISimulation_init() {
        this._simulationPropertyChanged = new BehaviorSubject<ISimulationChangedEvent>(undefined);
    }

    get SimulationPropertyChanged(): BehaviorSubject<ISimulationChangedEvent> {
        return this._simulationPropertyChanged
    }

    OnISimulationLoaded(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.WB_Simulation.setupOnChangeEvents([], self.ISimulation_onRecordChange.bind(self), self)
            resolve()
        })

    }

    private ISimulation_onRecordChange(record: WB_SimulationRow, propertyName: string, propertyValue: any, options: SimulationBO) {
        this.SimulationPropertyChanged.next({
            SimulationBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }


    //</editor-fold>

    //<editor-fold desc = "ICubeSource Operations">

    private _bICubeSourceLoaded: boolean
    private _onSourcePropertyChange: BehaviorSubject<ICubeSourceChangeEvent>
    private _onICubeSourceLoadComplete: Promise<void>
    private _arrLeafCells: SimulationPredictorInputCell[]

    private _dctDimensionHierarchies: { [DimType: string]: IHierarchy }
    private _dctCellMetrics: { [metricId: string]: ICellMetric }
    private _cubeSourceLoadMessageProvider: MessageProvider;
    private _cubeSourceLoadProgressProvider: ProgressProvider;
    private _qsCubeSource_syncLeafCells: ExecutionSerializer
    private _dctRefreshListByMetric: {[metricId:string]: string[]}

    private ICubeSource_init() {

        this._onSourcePropertyChange = new BehaviorSubject<{ Source: ICubeSource; PropertyName: string; PropertyValue: any }>(undefined)
        this._bICubeSourceLoaded = false
        this._onICubeSourceLoadComplete = undefined
        this._arrLeafCells = []
        this._cubeSourceLoadMessageProvider = new MessageProvider()
        this._cubeSourceLoadProgressProvider = new ProgressProvider()
        this._qsCubeSource_syncLeafCells = new ExecutionSerializer(this, this._ICubeSource_syncLeafCells.bind(this),
            [{}], 250, false)

        this._dctDimensionHierarchies = {}
        this._dctCellMetrics = {}
        this._dctRefreshListByMetric = {}
    }

    get CubeSourceName(): string {
        return this.WB_Simulation?.cif?.SIMULATION_ID + "_" + this.WB_Simulation?.cif?.SIMULATION_NAME
    }

    get CubeSourceLoadMessageProvider(): IMessageProvider {
        return this._cubeSourceLoadMessageProvider
    }

    get CubeSourceLoadProgressProvider(): IProgressProvider {
        return this._cubeSourceLoadProgressProvider
    }


    get OnICubeSourceLoadComplete(): Promise<void> {
        const self = this

        if (self._bICubeSourceLoaded)
            return Promise.resolve()

        if (!_.isEmpty(self._onICubeSourceLoadComplete))
            return self._onICubeSourceLoadComplete

        let returnValue = self._onICubeSourceLoadComplete = (async () => {

            // Create Dimensions
            await self.OnIHaveModelLoaded
            let modelRow = self.Model.WB_Model

            let aProductHierarchy = new ProductHierarchy(modelRow.cif.WB_PRDH_ID, self.WB_Simulation.StartDate, self.WB_Simulation.EndDate)
            let aTimeHierarchy = new PeriodHierarchy(modelRow.cif.WB_PERIODH_ID)
            await Promise.all([aProductHierarchy.OnLoadComplete, aTimeHierarchy.OnLoadComplete])
            self._dctDimensionHierarchies[DimensionType.Product] = aProductHierarchy
            self._dctDimensionHierarchies[DimensionType.Time] = aTimeHierarchy

            // Create Metrics
            await self.Model.OnIHaveModelPredictorsLoaded
            let arrPredictors = self.Model.ModelPredictors
            _.forEach(arrPredictors, (aPredictor) => {
                let aPredictorMetric = new SimulatorPredictorMetric(aPredictor)
                self._dctCellMetrics[aPredictorMetric.MetricId] = aPredictorMetric
            })
            let ids: any = []
            _.forEach(self.WB_Simulation.WB_SimulationTypeRow.WB_SimulationTypeInputRelationshipRows, (row: any) => {
                if (!row.WB_SimulationInputRow) {
                    ids.push(row.cif.WB_SIMULATION_INPUT_ID)
                }
            })

            let simulationInputRecords = await self.dbContext.findAll(esWB_Simulation_Input, {where: {WB_SIMULATIONM_ID: {inq: ids}}})
            _.forEach(self.WB_Simulation.WB_SimulationTypeRow.WB_SimulationTypeInputRelationshipRows, (row: any) => {
                row.cif.WB_SimulationInputRow = _.find(simulationInputRecords, (data) => data.cif.WB_SIMULATION_INPUT_ID === row.cif.WB_SIMULATION_INPUT_ID)
            })
            let arrInputs = _.map(_.filter(self.WB_Simulation.WB_SimulationTypeRow.WB_SimulationTypeInputRelationshipRows, (aRow) => aRow.isActive), (b) => b.WB_SimulationInputRow)
            _.forEach(arrInputs, (aSimInputRow) => {
                if (_.isEmpty(aSimInputRow))
                    return
                let anInputMetric = new SimulatorInputMetric(aSimInputRow)
                self._dctCellMetrics[anInputMetric.MetricId] = anInputMetric
            })

            self._dctRefreshListByMetric = CellMetricUtils.getRefreshMetricParentsByMetricId(self)

            // Sync Cube Cells
            await self._ICubeSource_syncLeafCells({})

            // Setup Listener on Predictor and Input change
            self.OnIHaveSimulationPredictorsAndInputsChanged.subscribe((obj) => {
                // Sync Leaf Cells
                self.ICubeSource_syncLeafCells()
            })

            self._bICubeSourceLoaded = true

        })();

        return returnValue
    }

    private get CubeSourceLeafCells(): SimulationPredictorInputCell[] {
        return this._arrLeafCells
    }

    get OnCubeSourcePropertyChange(): BehaviorSubject<ICubeSourceChangeEvent> {
        return this._onSourcePropertyChange
    }

    get bICubeSourceLoaded(): boolean {
        return this._bICubeSourceLoaded
    }

    createPerspective(name: string, options: ICubePerspectiveOptions): ICubePerspective {
        return new Perspective(name, this, options, {cells:  this.CubeSourceLeafCells});
    }


    getDimensionHierarchy(dimensionType: DimensionType): IHierarchy {
        return this._dctDimensionHierarchies[dimensionType];
    }

    getDimensions(): DimensionType[] {
        return [DimensionType.Product, DimensionType.Time];
    }

    getCompositeLeafKeys(dimensionTypeIds: DimensionType[]): Promise<IDimensionCompositeKeys> {
        //-- TODO: We don't need it until we do filtering of the dimensions
        return Promise.resolve(undefined);
    }

    getDistinctLeafKeys(dimensionTypeIds: DimensionType[]): Promise<IDimensionDistinctKeys> {
        //-- TODO: We don't need it until we do filtering of the dimensions
        return Promise.resolve(undefined);
    }

    getMetric(metricId: string): ICellMetric {
        return this._dctCellMetrics[metricId];
    }

    getMetrics(): ICellMetric[] {
        return _.values(this._dctCellMetrics);
    }

    getRefreshMetricIds(aMetricId: string): string[] {
        return (this._dctRefreshListByMetric[aMetricId] || [aMetricId]);
    }


    ICubeSource_syncLeafCells(): void {
        //  debounce calls ...
        console.log("Synchronizing Cube Source Leaf Cells: qsRun")
        this._qsCubeSource_syncLeafCells.Run({})
    }

    private async _ICubeSource_syncLeafCells(opts: any): Promise<void> {
        const self = this

        let dctLeafCells: {
            [wbPrdGrpId: string]: {
                [wbPeriodId: string]: {
                    Cell: SimulationPredictorInputCell,
                    Predictor: WB_SimulationPredictorRelationshipRow,
                    Input: WB_SimulationInputRelationshipRow
                }
            }
        } = {}

        // Read in all the Inputs and Predictors and Place in Dictionary
        _.forEach(self.WB_Simulation.WB_SimulationPredictorRelationshipRows, (aRow) => {
            if (!aRow.isActive)
                return

            let wbPrdGrpId = aRow.cif.WB_PRDGRP_ID
            let wbPeriodId = aRow.cif.WB_PERIOD_ID

            if (!(wbPrdGrpId in dctLeafCells))
                dctLeafCells[wbPrdGrpId] = {}

            if (!(wbPeriodId in dctLeafCells[wbPrdGrpId])) {
                dctLeafCells[wbPrdGrpId][wbPeriodId] = {
                    Cell: undefined,
                    Input: undefined,
                    Predictor: undefined
                }
            }

            if (_.isUndefined(dctLeafCells[wbPrdGrpId][wbPeriodId].Predictor))
                dctLeafCells[wbPrdGrpId][wbPeriodId].Predictor = aRow
            else {
                //-- Error condition, duplicate Predictor detected
            }

        })

        _.forEach(self.WB_Simulation.WB_SimulationInputRelationshipRows, (aRow) => {
            if (!aRow.isActive)
                return

            let wbPrdGrpId = aRow.cif.WB_PRDGRP_ID
            let wbPeriodId = aRow.cif.WB_PERIOD_ID

            if (!(wbPrdGrpId in dctLeafCells))
                dctLeafCells[wbPrdGrpId] = {}

            if (!(wbPeriodId in dctLeafCells[wbPrdGrpId])) {
                dctLeafCells[wbPrdGrpId][wbPeriodId] = {
                    Cell: undefined,
                    Input: undefined,
                    Predictor: undefined
                }
            }

            if (_.isUndefined(dctLeafCells[wbPrdGrpId][wbPeriodId].Input))
                dctLeafCells[wbPrdGrpId][wbPeriodId].Input = aRow
            else {
                //-- Error condition, duplicate Input detected
            }

        })

        //--  Slot in existing Cells
        _.forEach(self.CubeSourceLeafCells, (aCell) => {
            let wbPrdGrpId = aCell.getKey(DimensionType.Product)
            let wbPeriodId = aCell.getKey(DimensionType.Time)

            if (!(wbPrdGrpId in dctLeafCells)) {
                //--PG removed
                return
            }

            if (!(wbPeriodId in dctLeafCells[wbPrdGrpId])) {
                //-- Period removed
                return
            }

            if (_.isUndefined(dctLeafCells[wbPrdGrpId][wbPeriodId].Cell))
                dctLeafCells[wbPrdGrpId][wbPeriodId].Cell = aCell
            else {
                //-- Error condition, duplicate Cell detected
            }

        })

        // Reconstruct the Cell
        let arrNewLeafCells: SimulationPredictorInputCell[] = []
        _.forEach(dctLeafCells, (dctSub, wbPrdGrpId) => {
            _.forEach(dctSub, (group, wbPeriodId) => {
                if (_.isEmpty(group.Input) || _.isEmpty(group.Predictor)) {
                    // Missing one of pair
                    return
                }

                if (_.isEmpty(group.Cell)) {
                    group.Cell = new SimulationPredictorInputCell(self, group.Predictor, group.Input)
                } else if (!group.Cell.rowsMatch(group.Predictor, group.Input)) {
                    group.Cell = new SimulationPredictorInputCell(self, group.Predictor, group.Input)
                }

                arrNewLeafCells.push(group.Cell)
            })
        })

        //
        self._arrLeafCells = arrNewLeafCells
        self.OnCubeSourcePropertyChange.next({Source: self, PropertyName: "Perspective", PropertyValue: undefined})
    }


    //</editor-fold>

    //<editor-fold desc = "IHaveProductGroup operations">

    _bIHaveProductGroupsLoaded: boolean;
    _OnIHaveProductGroupsLoaded: Promise<IHaveProductGroups>;
    _ProductGroupsAll: WB_ProductGroupRow[]

    IHaveProductGroups_init() {
        this.ProductGroupsChanged = new BehaviorSubject<IHaveProductGroups>(this)
        this._bIHaveProductGroupsLoaded = false
        this._OnIHaveProductGroupsLoaded = undefined
        this._ProductGroupsAll = []
    }


    ProductGroupsChanged: BehaviorSubject<IHaveProductGroups>;

    get bIHaveProductGroupsLoaded(): boolean {
        return this._bIHaveProductGroupsLoaded
    }

    get OnIHaveProductGroupsLoaded(): Promise<IHaveProductGroups> {

        const self = this;

        if (self.bIHaveProductGroupsLoaded) {
            return ASync.resolve(self)
        }

        if (!_.isEmpty(self._OnIHaveProductGroupsLoaded))
            return self._OnIHaveProductGroupsLoaded; // Load already started, wait on same Promise

        let returnValue = self._OnIHaveProductGroupsLoaded = new Promise<IHaveProductGroups>((resolve, error) => {
            // If the BO is not loaded, throw an error.. It should have been started
            if ((!(self.bIsLoaded)) && (_.isEmpty(self.OnLoadComplete))) {
                error("Simulation isn't Loaded or Loading.. Can't determine Product Groups");
                return;
            }

            let boLoadPromise = undefined
            if (self.bIsLoaded) {
                boLoadPromise = ASync.resolve(self)
            } else {
                boLoadPromise = self.OnLoadComplete
            }
            boLoadPromise
                .then(() => {
                    return self.dbContext.find(esWB_Model_Coeff_Set,
                                self.WB_Simulation?.WB_PublishedModelRow?.cif?.WB_MODEL_COEFF_SET_ID)
                })
                .then((aSet:WB_ModelCoefficientSetRow)=>{
                    if (!_.isEmpty(aSet))
                        return PASearch.findByRequest(
                            {
                                model: esWB_Modeling_Session_ProdR,
                                where: {
                                    "DELETED_IND": {"neq": '1'},
                                    "WB_MODELING_SESSION_ID": aSet?.cif?.WB_MODELING_SESSION_ID
                                }
                            })
                })
                .then((results:any[]) => {
                    let arrWbPrdGrpId = _.map(results, "WB_PRDGRP_ID")
                    return self.dbContext.findUsingCache(esWB_Product_Group, arrWbPrdGrpId)
                })
                .then((arrPGs: WB_ProductGroupRow[]) => {
                    self._ProductGroupsAll = arrPGs || []
                    this._bIHaveProductGroupsLoaded = true;
                    this._OnIHaveProductGroupsLoaded = undefined

                    resolve(self);

                })
                .catch((err) => {
                    error(err)
                })


        });


        return returnValue;
    }


    get ProductGroups(): WB_ProductGroupRow[] {
        return _.map(_.filter(this.WB_Simulation.WB_SimulationProductRows, (aRow) => aRow.isActive), (aRow) => aRow.WB_ProductGroupRow)
    }

    get AllProductGroups(): WB_ProductGroupRow[] {
        return this._ProductGroupsAll
    }

    get ProductGroupsReadOnly(): boolean {

        // TODO: Check Security Roles..
        return false;
    }

    addProductGroups(arrProductGroupId: number[]): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            self.dbContext.findUsingCache(esWB_Product_Group, arrProductGroupId)
                .then((arrPrdGrpRows: WB_ProductGroupRow[]) => {

                    async function createProductGroupRows() {
                        for (let idx in arrPrdGrpRows) {
                            let aWB_PrdGrpRow = arrPrdGrpRows[idx]
                            let newRecord: WB_PlanProductGroupRow = <any>await self.dbContext.createRecordWithKey(esWB_Simulation_Product)
                            newRecord.setDefaults()
                            newRecord.cif.WB_SIMULATION_ID = self.WB_Simulation.cif.WB_SIMULATION_ID
                            newRecord.cif.WB_PRDGRP_ID = aWB_PrdGrpRow.cif.WB_PRDGRP_ID
                            newRecord.WB_ProductGroupRow = aWB_PrdGrpRow
                            self.dbContext.add(esWB_Simulation_Product, newRecord)
                        }
                        self.ProductGroupsChanged.next(self)
                    }

                    return createProductGroupRows()
                })
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })
    }


    addProductGroup(ProductGroupId: number): Promise<void> {
        const self = this

        return self.addProductGroups([ProductGroupId])
    }

    removeProductGroups(arrProductGroupId: number[]): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            let bChanged = false
            _.forEach(self.WB_Simulation.WB_SimulationProductRows, (aRow) => {
                if (aRow.isActive && _.includes(arrProductGroupId, aRow.cif.WB_PRDGRP_ID)) {
                    bChanged = true
                    aRow.markDeleted()
                }
            })

            if (bChanged) {
                self.ProductGroupsChanged.next(self)
            }

            resolve()

        })
    }

    removeProductGroup(ProductGroupId: number): Promise<void> {
        const self = this

        return self.removeProductGroups([ProductGroupId])
    }

    hasProductGroup(ProductGroupId: number): boolean {
        const self = this
        let returnValue = false

        _.forEach(self.WB_Simulation.WB_SimulationProductRows, (aRow) => {
            if (aRow.isActive && aRow.cif.WB_PRDGRP_ID == ProductGroupId) {
                returnValue = true
                return false // stop iterating
            }
        })

        return returnValue
    }

    isProductGroupEditable(ProductGroupId: number): boolean {
        return true;
    }


//</editor-fold>

    //<editor-fold desc="IHaveModel Operations">

    private _Model: ModelBO;
    private _OnIHaveModelLoaded: Promise<void>;
    private _bIHaveModelLoaded: boolean;

    IHaveModel_init() {
        this._bIHaveModelLoaded = false
        this._OnIHaveModelLoaded = undefined
        this._Model = undefined
    }

    get bIHaveModelLoaded(): boolean {
        return this._bIHaveModelLoaded
    }

    get OnIHaveModelLoaded(): Promise<void> {
        const self = this

        if (self._OnIHaveModelLoaded)
            return self._OnIHaveModelLoaded

        let returnValue = self._OnIHaveModelLoaded = new Promise<void>((resolve, error) => {
            let wbModelId = self.WB_Simulation.WB_PublishedModelRow.cif.WB_MODEL_ID
            if (!(wbModelId > 0)) {
                error(`No Model Specified: ${wbModelId}`)
                return
            }
            let aModel = new ModelBO()
            aModel.Load(wbModelId, {dbContext: self.dbContext})
                .then((ignore) => {
                    self._Model = aModel
                    self._bIHaveModelLoaded = true
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })

        return returnValue
    }

    get Model(): ModelBO {
        return this._Model
    }

//</editor-fold>

    //<editor-fold desc="IHaveSimulationCalculator operations">

    private _simulationCalculator: ISimulationCalculator;


    private IHaveSimulationCalculator_init() {
        this._simulationCalculator = new SimulationCalculator(this)
    }

    private IHaveSimulationCalculator_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self._simulationCalculator.Register(self)
            resolve()
        })

    }

    private IHaveSimulationCalculator_BeforeReload(): void {
        // Do nothing
    }

    get SimulationCalculator(): ISimulationCalculator {
        return this._simulationCalculator
    }

//</editor-fold>

    //<editor-fold desc="IHaveSimulationCollection Operations">


    private _SimulationsAll: WB_SimulationRow[];
    private _OnSimulationCollectionChanged: BehaviorSubject<IHaveSimulationCollection>;

    private IHaveSimulationCollection_init(): void {
        this._SimulationsAll = []
        this._OnSimulationCollectionChanged = new BehaviorSubject<IHaveSimulationCollection>(this)
    }

    private async IHaveSimulationCollection_afterLoadComplete(): Promise<void> {
        const self = this
        let wbPrdHId = self.Model.WB_Model.cif.WB_PRDH_ID
        let wbCustHId = self.Model.WB_Model.cif.WB_CUSTH_ID

        let arrModels: WB_ModelRow[] = <any> await self.dbContext.findAll(esWB_Model, {WB_PRDH_ID: wbPrdHId, WB_CUSTH_ID: wbCustHId, DELETED_IND: {neq: '1'}})
        let arrModelIds = _.map(arrModels, (a) => a.cif.WB_MODEL_ID)
        let arrPublishedModels: WB_Published_ModelRow[] = <any> await self.dbContext.findAll(esWB_Published_Model, {WB_MODEL_ID: {inq: arrModelIds }})
        let arrPublishedModelIds = _.map(arrPublishedModels, (a) => a.cif.WB_PUBLISHED_MODEL_ID)

        let arrSimulations: WB_SimulationRow[] = <any> await self.dbContext.findAll(esWB_Simulation, {WB_PUBLISHED_MODEL_ID: {inq: arrPublishedModelIds }, DELETED_IND: {neq: '1'}})
        this._SimulationsAll = arrSimulations

    }

    get  SimulationPrimary(): WB_SimulationRow {
        return this.WB_Simulation
    }

    get Simulations(): WB_SimulationRow[] {
        let returnValue: WB_SimulationRow[] = []

        _.forEach(this.WB_Simulation?.WB_SimulationRelationshipRows, (aRow: WB_SimulationRelationshipRow) => {
            if(!aRow.isActive)
                return

            if(!aRow.WB_SimulationRow_Rel)
                return

            if(!aRow.WB_SimulationRow_Rel.isActive) {
                aRow.markDeleted()
                return
            }

            returnValue.push(aRow.WB_SimulationRow_Rel)
        })

        if(this.WB_Simulation)
            returnValue.unshift(this.WB_Simulation)

        return returnValue
    }

    get SimulationsAll(): WB_SimulationRow[] {
        return this._SimulationsAll
    }

    get OnSimulationCollectionChanged(): BehaviorSubject<IHaveSimulationCollection> {
        return this._OnSimulationCollectionChanged
    }

    async addSimulation(wbSimulationId: number): Promise<void> {
        const self = this
        if(wbSimulationId == self.WB_Simulation.cif.WB_SIMULATION_ID)
            return

        // Check if exists
        let bExists = false
        _.forEach(self.WB_Simulation.WB_SimulationRelationshipRows, (aRow) => {
            if(!aRow.isActive)
                return

            if(aRow.cif.WB_SIMULATION_ID_REL == wbSimulationId) {
                bExists = true
                return false
            }
        })

        if(bExists)
            return

        let simRow: WB_SimulationRow = <any> await self.dbContext.find(esWB_Simulation, wbSimulationId)
        if(!simRow)
            return

        let newRow: WB_SimulationRelationshipRow = <any> await self.dbContext.createRecordWithKey(esWB_Simulation_Relationship)
        newRow.setDefaults()
        newRow.cif.WB_SIMULATION_ID = self.WB_Simulation.cif.WB_SIMULATION_ID
        newRow.WB_SimulationRow = self.WB_Simulation
        newRow.cif.WB_SIMULATION_ID_REL = wbSimulationId
        newRow.WB_SimulationRow_Rel = simRow
        self.dbContext.add(esWB_Simulation_Relationship, newRow)

        self.OnSimulationCollectionChanged.next(self)
    }

    async removeSimulation(wbSimulationId: number): Promise<void> {
        const self = this

        let bExists = false
        _.forEach(self.WB_Simulation.WB_SimulationRelationshipRows, (aRow) => {
            if(!aRow.isActive)
                return

            if(aRow.cif.WB_SIMULATION_ID_REL == wbSimulationId) {
                bExists = true
                aRow.markDeleted()
            }
        })

        if(bExists)
            self.OnSimulationCollectionChanged.next(self)

    }

    async syncSimulations(arrWbSimulationId: number[]): Promise<void> {
        const self = this

        let arrExisting: number[] = []
        _.forEach(self.WB_Simulation.WB_SimulationRelationshipRows, (aRow) => {
            if(aRow.isActive && aRow.WB_SimulationRow_Rel)
                arrExisting.push(aRow.WB_SimulationRow_Rel.cif.WB_SIMULATION_ID)
        })

        let itemsToAdd = _.difference(arrWbSimulationId, arrExisting)
        let itemsToRemove = _.difference(arrExisting, arrWbSimulationId)

        for(let wbId of itemsToAdd)
            await self.addSimulation(wbId)

        for(let wbId of itemsToRemove)
            await self.removeSimulation(wbId)


    }


    //</editor-fold>

    //<editor-fold desc="IHaveSimulationCollectionCubeSource Operations">
    private _SimulationCollectionCubeSource: SimulationCollectionCubeSource = undefined

    private IHaveSimulationCollectionCubeSource_init(): void {
        // delay till after the load
    }

    private async IHaveSimulationCollectionCubeSource_afterLoadComplete(): Promise<void> {
        const self = this
        self._SimulationCollectionCubeSource = new SimulationCollectionCubeSource({simulationCollection: self, dbContext: self.dbContext, cubeSourceName: self.CubeSourceName })

        self.SimulationCalculator.OnCalculateComplete.subscribe((a) => {
            if(self.WB_Simulation && self._SimulationCollectionCubeSource)
            self._SimulationCollectionCubeSource.invalidateCache(self.WB_Simulation.cif.WB_SIMULATION_ID)
        })

    }

    get SimulationCollectionCubeSource(): SimulationCollectionCubeSource {
        return this._SimulationCollectionCubeSource
    }


    //</editor-fold>

    //<editor-fold desc = "Update Prices" >
    async updatePricing(): Promise<void> {
        let self = this
        let wbPricingEngineID = self.WB_Simulation.WB_SimulationTypeRow.WB_BusinessUnitRow.cif.WB_PRICINGENGINE_ID
        let arrInput: { [id: string]: string } = {}
        _.forEach(_.filter(self.WB_Simulation.WB_SimulationTypeRow.WB_SimulationTypeInputRelationshipRows, aRow => aRow.cif.PLACEMENT == 'Lookup'), aRow => {
            if (!_.isEmpty(aRow.WB_SimulationInputRow) && _.includes(['COGS', 'VCM', 'NetListPrice', 'GrossListPrice', 'FundingRate'], aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE)) {
                if (!_.isEmpty(arrInput[aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE]))
                    arrInput[aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE] += ","
                arrInput[aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE] = aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_ID
            }
        })


        for (let i = 0; i < self.WB_Simulation.WB_SimulationProductRows.length; i++) {
            let aPG = self.WB_Simulation.WB_SimulationProductRows[i]

            let aNetListPriceCondition: IwbProductCondition = undefined
            if ('NetListPrice' in arrInput) {
                aNetListPriceCondition = await PricingEngine.getCustomerNetListPrice(
                    wbPricingEngineID,
                    aPG.cif.WB_PRDGRP_ID,
                    self.WB_Simulation.cif.WB_CUST_ID,
                    0,
                    self.WB_Simulation.StartDate,
                    self.WB_Simulation.EndDate)
            }

            let aGrossListPriceCondition: IwbProductCondition = undefined
            if ('GrossListPrice' in arrInput) {
                aGrossListPriceCondition = await PricingEngine.getCustomerListPrice(
                    wbPricingEngineID,
                    aPG.cif.WB_PRDGRP_ID,
                    self.WB_Simulation.cif.WB_CUST_ID,
                    0,
                    self.WB_Simulation.StartDate,
                    self.WB_Simulation.EndDate)
            }

            let aVMCCondition: IwbProductCondition = undefined
            if ('VCM' in arrInput) {
                aVMCCondition = await PricingEngine.getCustomerVCM(
                    wbPricingEngineID,
                    aPG.cif.WB_PRDGRP_ID,
                    self.WB_Simulation.cif.WB_CUST_ID,
                    0,
                    self.WB_Simulation.StartDate,
                    self.WB_Simulation.EndDate)

            }

            let aCOGSCondition: IwbProductCondition = undefined
            if ('COGS' in arrInput) {

                aCOGSCondition = await PricingEngine.getCustomerCOGS(
                    wbPricingEngineID,
                    aPG.cif.WB_PRDGRP_ID,
                    self.WB_Simulation.cif.WB_CUST_ID,
                    0,
                    self.WB_Simulation.StartDate,
                    self.WB_Simulation.EndDate)

            }

            let arrFundingRate: { [id: string]: IwbProductCondition } = {}
            if ('FundingRate' in arrInput) {
                _.forEach(_.filter(self.WB_Simulation.WB_SimulationTypeRow.WB_SimulationTypeInputRelationshipRows, aRow => aRow.isActive && aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE == "FundingRate"), async aRow => {
                    let aRate = await PricingEngine.getPrdGrpFundingRateTotal(
                        aPG.cif.WB_PRDGRP_ID,
                        self.WB_Simulation.cif.WB_CUST_ID,
                        aRow.WB_SimulationInputRow.cif.WB_FUNDTYPE_ID,
                        0,
                        0,
                        aRow.WB_SimulationInputRow.cif.PRD_CNDM_ID_STD,
                        aRow.WB_SimulationInputRow.cif.PRD_CNDM_ID_ADDL,
                        self.WB_Simulation.StartDate,
                        self.WB_Simulation.EndDate)
                    arrFundingRate[aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_ID] = aRate
                })
            }


            _.forEach(_.filter(self.WB_Simulation.WB_SimulationInputRelationshipRows, aRow => aRow.cif.WB_PRDGRP_ID == aPG.cif.WB_PRDGRP_ID), anInputRow => {
                if (!_.isEmpty(aNetListPriceCondition))
                    anInputRow.cif[arrInput['NetListPrice']] = aNetListPriceCondition.VALUE_RATEAMOUNT
                if (!_.isEmpty(aGrossListPriceCondition))
                    anInputRow.cif[arrInput['GrossListPrice']] = aGrossListPriceCondition.VALUE_RATEAMOUNT
                if (!_.isEmpty(aVMCCondition))
                    anInputRow.cif[arrInput['VCM']] = aVMCCondition.VALUE_RATEAMOUNT
                if (!_.isEmpty(aCOGSCondition))
                    anInputRow.cif[arrInput['COGS']] = aCOGSCondition.VALUE_RATEAMOUNT

                if (!_.isEmpty(arrFundingRate))
                    _.forEach(arrInput['FundingRate'].split(","), anInput => {
                        anInputRow.cif[anInput] = arrFundingRate[anInput].VALUE_RATEAMOUNT
                    })


            })
        }
        return
    }

//</editor-fold>

    //<editor-fold desc = "Record Resolver Operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {
        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const simulation_options: CreateOptions = {
            standardConditions: {
                [esWB_Simulation]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Simulation_Type]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Simulation_Predictor_Relationship]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Simulation_Input_Relationship]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Simulation_Input]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Simulation_Product]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Simulation_Metric]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Simulation_Type_Input_Relationship]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Published_Model]: {"DELETED_IND": {"notIn": ['1']}}
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Published_Model]: [esWB_Model, esWB_Model_Coeff_Set, esWB_User],
                [esWB_Simulation_Type]: [esWB_Simulation_Type_Input_Relationship]
            },

        };

        const aRecResolver = new ESRecordResolver(dbContext, simulation_options);
        return aRecResolver;
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {
        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Simulation, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

//</editor-fold>



}

PAEnvironment.registerBusinessObjectClass(SimulationBO, "SimulationBO", "Simulation")